<app-dialog
  [visible]="visible"
  [width]="'900px'"
  [showHeader]="false"
  [closable]="true"
  (visibleChange)="visibleChange.emit($event)">
  <ng-container ngProjectAs="header">
    <div class="detail-modal__header">
      <div class="detail-modal__title-block">
        <h2>{{ item?.title }}</h2>
        <span class="detail-modal__subtitle">
          {{ regionPath || ("UPLOADED_GEO_IMAGES.NO_REGION" | translate) }}
        </span>
      </div>
      <button
        class="modal-close-btn"
        type="button"
        (click)="close()">
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M15 5L5 15M5 5L15 15"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </button>
    </div>
  </ng-container>
  <ng-container ngProjectAs="content">
    <div class="detail-modal__content">
      <div class="detail-image-wrapper">
        <img
          [src]="imageUrl || 'assets/icons/main/light/upload-img-bg.svg'"
          [alt]="item?.title || ''"
          class="detail-image" />
      </div>
      <div class="detail-meta">
        <div class="meta-item">
          <span class="meta-label">{{ "UPLOADED_GEO_IMAGES.DETAIL_CAPTURE_DATE" | translate }}</span>
          <span class="meta-value">{{ item?.captureDateUtc ? (item?.captureDateUtc | date: "dd.MM.yy HH:mm") : "-" }}</span>
        </div>
        <div class="meta-item">
          <span class="meta-label">{{ "UPLOADED_GEO_IMAGES.DETAIL_UPLOAD_DATE" | translate }}</span>
          <span class="meta-value">{{ item?.uploadDateUtc | date: "dd.MM.yy HH:mm" }}</span>
        </div>
        <div
          class="meta-item"
          *ngIf="item?.latitude != null && item?.longitude != null">
          <span class="meta-label">{{ "UPLOADED_GEO_IMAGES.DETAIL_COORDINATES" | translate }}</span>
          <span class="meta-value">{{ item?.latitude | number: "1.4-6" }}, {{ item?.longitude | number: "1.4-6" }}</span>
        </div>
        <div
          class="meta-item"
          *ngIf="footprintExtent">
          <span class="meta-label">{{ "UPLOADED_GEO_IMAGES.DETAIL_FOOTPRINT" | translate }}</span>
          <span class="meta-value">{{ footprintExtent }}</span>
        </div>
      </div>
      <div
        class="detail-tags"
        *ngIf="item?.tags?.length">
        <span class="section-label">{{ "UPLOADED_GEO_IMAGES.MODAL_TAGS" | translate }}</span>
        <div class="tag-chips">
          <span
            class="tag-chip"
            *ngFor="let tag of item?.tags">
            {{ tag.name }}
          </span>
        </div>
      </div>
      <div
        class="detail-description"
        *ngIf="item?.description">
        <span class="section-label">{{ "UPLOADED_GEO_IMAGES.DETAIL_DESCRIPTION" | translate }}</span>
        <p>{{ item?.description }}</p>
      </div>
    </div>
  </ng-container>
  <ng-container ngProjectAs="footer">
    <div class="detail-modal__footer">
      <app-primary-button
        [width]="'140px'"
        [title]="'UPLOADED_GEO_IMAGES.ACTION_EDIT' | translate"
        (action)="handleEdit()"></app-primary-button>
      <!-- No catalog button carries a destructive style (DEV-RULES §4.1 lists only primary/secondary/save/
           clear/export/back); app-button variant="danger" is what the sibling field-photo-delete-modal
           uses for the same gap. -->
      <app-button
        variant="danger"
        (onClick)="handleDelete()">
        {{ "UPLOADED_GEO_IMAGES.ACTION_DELETE" | translate }}
      </app-button>
    </div>
  </ng-container>
</app-dialog>
